import { call, put, select } from 'redux-saga/effects';

import getMyDataPromise from '@gc-npm/adabyron.client.datos-cliente.mis-datos';
import renttorent from '@gc-npm/adabyron.catalogue.renttorent';
import { actions as uiActions } from '@/reducers/ui';
import { actions as clientActions } from '@/reducers/client';
import {
  LOGED_COOKIE,
  SOFTLOGED_COOKIE,
  LOGIN_TYPES,
  API_STATUS,
} from '@/utils/constants';
import { getTaponInfo } from '@/utils';

const filePath = '/sagas/client.js';

const mainStore = (state) => state.main;
const clientStore = (state) => state.client;

export function* getLoginType({ document }) {
  let loginType = null;

  if (document && document.cookie) {
    
    if (document.cookie.includes(LOGED_COOKIE)) {
      loginType = LOGIN_TYPES.LOGGED;
    } else if (document.cookie.includes(SOFTLOGED_COOKIE)) {
      loginType = LOGIN_TYPES.SOFTLOGGED;
    }
    if (loginType) {
       yield put(clientActions.setLoginType(loginType));
    }
  }
}

export const normalizeMyData = (info) => {
  let myDataNormalized = null;

  const { datos } = info || {};

  if (datos) {
    const {
      fullName, documentType, numberDocument, contactsForms, customerId,
    } = datos;
    let phone = '';
    let sms = '';
    let email = '';

    if (
      contactsForms
      && Array.isArray(contactsForms)
      && contactsForms.length > 0
    ) {
      contactsForms.forEach(({ contactType, value }) => {
        switch (contactType) {
          case 'TELF':
            phone = value;
            break;
          case 'SMS_':
            sms = value;
            break;
          case 'EMAI':
            email = value;
            break;
          default:
            break;
        }
      });
    }

    myDataNormalized = {
      fullName,
      documentType,
      numberDocument,
      customerId,
      phone,
      email,
      sms,
    };
  }

  return myDataNormalized;
};

export function* getMyData() {
  let misDatos = null;

  const main = yield select(mainStore);
  const { context } = main;

  yield put(clientActions.setStatus(API_STATUS.LOADING));

  try {
    const myData = yield call(getMyDataPromise, { context });
    misDatos = normalizeMyData(myData);
    if (misDatos) {
      yield put(clientActions.setStatus(API_STATUS.OK));
      yield put(clientActions.setMyData(misDatos));
    } else {
      throw new ReferenceError(
        'getMyData',
        filePath,
      );
    }
  } catch (error) {
    yield put(clientActions.setStatus(API_STATUS.KO));
    if (error?.statusCode === 401) {
      yield put(clientActions.setMyData(401));
      misDatos = 401;
    }
  }

  return misDatos;
}

const normalizeMyR2R = (myR2rInfo, newInfo) => {
  let myR2RNormalized = null;

  const { datos } = newInfo || {};

  if (datos) {
    const { productosRentToRent } = datos;

    if (
      productosRentToRent
      && Array.isArray(productosRentToRent)
      && productosRentToRent.length > 0
      && myR2rInfo
      && Array.isArray(myR2rInfo)
      && myR2rInfo.length > 0
    ) {
      myR2RNormalized = [];
      productosRentToRent.forEach((productoRentToRent) => {
        const { idPO, cuotaActual, cuotaFutura } = productoRentToRent;
        const r2rFound = myR2rInfo.find(
          ({ productOfferingId }) => productOfferingId === idPO,
        );
        if (r2rFound) {
          myR2RNormalized.push({
            ...r2rFound,
            cuotaActual,
            cuotaFutura,
          });
        }
      });
      if (myR2RNormalized.length === 0) {
        myR2RNormalized = null;
      }
    }
  }

  return myR2RNormalized;
}

export function* getMyR2R({ productOfferingConvergente }) {
  const main = yield select(mainStore);
  const client = yield select(clientStore);
  const { r2r } = client || {};
  const { context } = main;

  yield put(clientActions.setStatus(API_STATUS.LOADING));
  try {
    const myR2RData = yield call(renttorent, {
      productOfferingConvergente,
      context,
      ssrHeaders: {
        timeout: 60000,
      },
    });
    const myR2RNormalized = normalizeMyR2R(r2r, myR2RData);
    if (myR2RNormalized) {
      yield put(clientActions.setStatus(API_STATUS.OK));
      yield put(clientActions.setMyR2R(myR2RNormalized));
    } else {
      throw new ReferenceError(
        'getMyR2R',
        filePath,
      );
    }
  } catch (error) {
    if (error?.statusCode === 401) {
      yield put(clientActions.setStatus(401));
    } else {
      yield put(clientActions.setStatus(API_STATUS.KO));
    }
  }
}

export function* getRetention({ retentionModules }) {
  const main = yield select(mainStore);
  const client = yield select(clientStore);

  const { context } = main || {};

    const {
    bundleId,
    modulos,
    tv,
    oldTv,
    mobile,
    netflix,
    promotions,
    campaignsRedeemed,
    productZoneId,
    productCategory,
    price: clientPrice,
    productType,
    r2r,
  } = client;
  try {
    let hiredIds = [];
    let selectedIds = [];
    if (modulos && Array.isArray(modulos) && modulos.length > 0) {
      hiredIds = modulos.map(({ id }) => id);
      selectedIds = modulos
        .filter(({ id }) => !retentionModules.includes(id))
        .map(({ id }) => id);
    }
    const clientInfo = {
      modulos: hiredIds,
      promotions,
      campaignsRedeemed,
      tv,
      oldTv,
      mobile,
      netflix,
      productZoneId,
      productCategory,
      productType,
      r2r,
      clientPrice,
      bundleId
    };
    
    const retentionPromise = yield call(
      () => import('@gc-npm/adabyron.ssr.retention'),
    );
    const retention = yield call(retentionPromise.retention, {
      context,
      clientInfo,
      selectedIds,
    });
    // de momento nos quedamos con la promo mas prioritaria
    if (
      retention
      && retention.promotions
      && Array.isArray(retention.promotions)
      && retention.promotions.length > 0
    ) {
      retention.promotions = retention.promotions.slice(0, 1);
    } else {
      throw new ReferenceError(
        'getRetention',
        filePath,
      );
    }
    yield put(clientActions.setRetention(retention));
  } catch (error) {
    yield put(uiActions.setTapon({
      ...getTaponInfo(true, error?.statusCode || '500'),
      componentContent: `Fallo al obtener retencion de los paquetes: ${retentionModules.join(';')}`,
    }));
  }
}
